
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { 
  Select, 
  SelectContent, 
  SelectItem, 
  SelectTrigger, 
  SelectValue 
} from "@/components/ui/select";

interface MindfulnessStepProps {
  formData: {
    stressLevel: string;
    mindfulnessPractices: string[];
    mentalHealthConcerns: string;
  };
  handleInputChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  handleSelectChange: (name: string, value: string) => void;
  handleCheckboxChange: (list: string, value: string) => void;
}

export function MindfulnessStep({ 
  formData, 
  handleInputChange, 
  handleSelectChange, 
  handleCheckboxChange 
}: MindfulnessStepProps) {
  return (
    <div className="space-y-4">
      <div>
        <Label htmlFor="stressLevel">Stress Level</Label>
        <Select 
          onValueChange={(value) => handleSelectChange("stressLevel", value)}
          value={formData.stressLevel}
        >
          <SelectTrigger>
            <SelectValue placeholder="Rate your stress level" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="low">Low</SelectItem>
            <SelectItem value="moderate">Moderate</SelectItem>
            <SelectItem value="high">High</SelectItem>
            <SelectItem value="severe">Severe</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div>
        <Label>Current Mindfulness Practices</Label>
        <div className="space-y-2 mt-2">
          {["meditation", "yoga", "breathwork", "journaling", "nature-time", "prayer", "none"].map((practice) => (
            <div key={practice} className="flex items-center space-x-2">
              <Checkbox
                id={practice}
                checked={(formData.mindfulnessPractices as string[]).includes(practice)}
                onCheckedChange={() => handleCheckboxChange("mindfulnessPractices", practice)}
              />
              <Label htmlFor={practice}>
                {practice === "none" 
                  ? "No current mindfulness practice" 
                  : practice.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
              </Label>
            </div>
          ))}
        </div>
      </div>

      <div>
        <Label htmlFor="mentalHealthConcerns">Mental Health Concerns</Label>
        <Textarea
          id="mentalHealthConcerns"
          name="mentalHealthConcerns"
          value={formData.mentalHealthConcerns}
          onChange={handleInputChange}
          placeholder="Share any mental health concerns you'd like support with (optional)"
          className="resize-none"
        />
      </div>
    </div>
  );
}
